// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3HON1","fileBtn":"File_fileBtn__3csPf","closeBtn":"File_closeBtn__14Q2m","fileSelected":"File_fileSelected__3xbsr","disabled":"File_disabled__1ShX1"};